import { RestService } from "@sinossi/mates-react-library"

import {
    AssetMatchBrand,
    BrandPriority,
    PaginatedResponse,
} from "models"
import {CreateResearchRequest, EditResearchRequest} from "../models/priorities";

export class ResearchService
{
    static getResearchList = (request: {limit: number, page: number}, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<BrandPriority>>(`/api/brand/priorities/list`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getResearchResult = (request: {limit: number, page: number}, priorityId: string, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrand>>(`/api/brand/priorities/${priorityId}/match`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static editResearch = (brandId: string, request: EditResearchRequest, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/brand/${brandId}/priorities`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static createResearch = (request: CreateResearchRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/brand/priorities`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static deleteResearch = (priorityId: string, callback: any, catchCallback: any) => {
        RestService
            .delete(`/api/brand/priorities/${priorityId}`)
            .then(callback)
            .catch(catchCallback)
    }
}
